/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";

import { withTranslation } from "react-i18next";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import { isArray } from "../../Libs/CustomMethods/customMethods";

import {
  resetGoals,
  resetError,
  getGoals,
  deleteGoal,
} from "../../store/goals/actions";

import { AvForm, AvField } from "availity-reactstrap-validation";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import "moment-duration-format";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Goals = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataGoal,
    dataGoalDelete,
    loadingGoal,
    loadingGoalDelete,
    errorGoal,
    successGoal,
  } = useSelector((state) => state.Goals);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [goalIdName, setGoalIdName] = useState({ id: null, name: null });
  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successGoal && dispatch(resetGoals()) && handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getGoals(1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deleteGoal(goalIdName?.id));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getGoals(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataGoal?.paging) {
      if (page < dataGoal.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataGoalDelete && dataGoalDelete.message) {
      showToast("success", t(dataGoalDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successGoal]);

  useEffect(() => {
    if (isArray(errorGoal) && errorGoal?.length > 0) {
      errorGoal.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "Goal not exists." &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorGoal) {
        showToast("error", t(errorGoal));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorGoal]);

  useEffect(() => {
    if (dataGoal !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataGoal]);

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/goals"
            title={t("Dashboard")}
            breadcrumbItem={t("Goals")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-goal">
                          <Link to={`/goal`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Goal")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th>{t("Group")}</th>
                            <th>{t("Type")}</th>
                            <th>{t("Value")}</th>
                            <th>{t("Tooltip")}</th>
                            <th className="text-right pr-4">{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingGoal ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataGoal?.responseGoal?.length > 0 ? (
                            dataGoal.responseGoal.map((goal, key) => (
                              <tr key={key}>
                                <td className="column-text-overflow-25">
                                  {goal.name}
                                </td>
                                <td className="column-text-overflow-25">
                                  {goal.group}
                                </td>
                                <td className="column-text-overflow-25">
                                  {t(goal.type)}
                                </td>
                                <td className="column-text-overflow-25">
                                  {goal.value}
                                </td>
                                <td className="column-text-overflow-25">
                                  {goal.tooltip}
                                </td>
                                <td className="text-right">
                                  <Link
                                    to={`/goal/${goal.id}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id={`edittooltip${key}`}
                                    />
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`edittooltip${key}`}
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  <span className="pointer">
                                    <i
                                      className="mdi mdi-window-close text-danger font-size-18 px-2"
                                      id={`deletetooltip${key}`}
                                      onClick={() => {
                                        toggleModal();
                                        setGoalIdName({
                                          id: goal?.id,
                                          name: goal?.name,
                                        });
                                      }}
                                    />
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`deletetooltip${key}`}
                                    >
                                      {t("Delete")}
                                    </UncontrolledTooltip>
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingGoalDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the goal")}
                          <strong> {goalIdName?.name}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingGoalDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                goalIdName?.id && handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataGoal?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Goals);
